import {
  Beef,
  Croissant,
  Egg,
  Flower2,
  Package,
  Salad,
  Soup,
  Sprout,
  Sparkles,
} from "lucide-react";

// Shown wherever a listing has no photo yet. Deliberately NOT a stock
// photograph: a candle maker's listing rendered behind a stock shot of
// vegetables misrepresents the product, and on a marketplace whose whole pitch
// is knowing who grew your food, borrowed imagery is the wrong lie to tell.
// A category glyph is honest about being a placeholder and can never be wrong
// about the product.
const CATEGORY_ICON: Record<string, typeof Package> = {
  produce: Salad,
  eggs: Egg,
  baked: Croissant,
  prepared: Soup,
  meat: Beef,
  pantry: Package,
  flowers: Flower2,
  garden: Sprout,
  homemade: Sparkles,
  other: Package,
};

// xs is for the ~56-80px thumbnails in carts and box strips, where any caption
// would be unreadable, so the glyph carries it alone.
export function ListingPhotoPlaceholder({
  category,
  size = "md",
  className,
}: {
  category?: string | null;
  size?: "xs" | "sm" | "md";
  className?: string;
}) {
  const Icon = CATEGORY_ICON[String(category || "").trim()] || Package;
  const iconSize = size === "xs" ? "h-5 w-5" : size === "sm" ? "h-6 w-6" : "h-8 w-8";
  return (
    <div
      className={`flex h-full w-full flex-col items-center justify-center gap-1.5 bg-muted/45 text-muted-foreground ${className || ""}`}
      title="The maker hasn't added a photo yet"
    >
      <Icon className={`${iconSize} opacity-40`} aria-hidden />
      {size !== "xs" && (
        <span className="px-2 text-center text-[10px] font-medium leading-tight opacity-80">
          Photo coming soon
        </span>
      )}
    </div>
  );
}
